module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//15.jpg?3cb67a7959b7194d974a35ede447f03b";